import { render, staticRenderFns } from "./service-providers.vue?vue&type=template&id=3ee16dd9&scoped=true"
import script from "./service-providers.vue?vue&type=script&lang=js"
export * from "./service-providers.vue?vue&type=script&lang=js"
import style0 from "./service-providers.vue?vue&type=style&index=0&id=3ee16dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee16dd9",
  null
  
)

export default component.exports